import { useState } from 'react'
import { Form, Input, Modal, Typography, message } from 'antd'
import { api } from '../api'

type Props = {
  open: boolean
  requireOldPassword?: boolean
  onSuccess: () => void
  onDefer?: () => void
}

export default function ChangePasswordModal({
  open,
  requireOldPassword = false,
  onSuccess,
  onDefer,
}: Props) {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)

  const submit = () => {
    void form.validateFields().then((v) => {
      setLoading(true)
      const body = requireOldPassword
        ? { old_password: v.old_password, new_password: v.new_password }
        : { new_password: v.new_password }
      api
        .post('/auth/change-password', body)
        .then(() => {
          message.success('密码已更新')
          form.resetFields()
          onSuccess()
        })
        .catch((e) => message.error(e.message))
        .finally(() => setLoading(false))
    })
  }

  return (
    <Modal
      title="首次登录，请修改密码"
      open={open}
      onOk={submit}
      onCancel={onDefer}
      okText="保存新密码"
      cancelText="稍后设置"
      confirmLoading={loading}
      closable={false}
      mask={{ closable: false }}
      keyboard={false}
      cancelButtonProps={requireOldPassword || !onDefer ? { style: { display: 'none' } } : undefined}
    >
      <Typography.Paragraph type="secondary">
        为保障账号安全，建议尽快设置个人登录密码。您也可选择「稍后设置」，本次登录内可继续使用系统。
      </Typography.Paragraph>
      <Form form={form} layout="vertical">
        {requireOldPassword && (
          <Form.Item
            name="old_password"
            label="当前密码"
            rules={[{ required: true, message: '请输入当前密码' }]}
          >
            <Input.Password placeholder="当前登录密码" />
          </Form.Item>
        )}
        <Form.Item
          name="new_password"
          label="新密码"
          rules={[
            { required: true, message: '请输入新密码' },
            { min: 4, message: '至少 4 位' },
          ]}
        >
          <Input.Password placeholder="新登录密码" />
        </Form.Item>
        <Form.Item
          name="confirm_password"
          label="确认新密码"
          dependencies={['new_password']}
          rules={[
            { required: true, message: '请再次输入新密码' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('new_password') === value) return Promise.resolve()
                return Promise.reject(new Error('两次输入的密码不一致'))
              },
            }),
          ]}
        >
          <Input.Password placeholder="再次输入新密码" />
        </Form.Item>
      </Form>
    </Modal>
  )
}
